import baseApi from "@/api/baseApi";

export default {
  cancel(queries) {
    return baseApi.post(`/api-article/delivery-set-clearing/v1/cancel`, queries)
  },
  complete(query) {
    return baseApi.post(`/api-article/delivery-set-clearing/v1/complete?${query}`)
  },
  completeMultiple(query) {
    return baseApi.post(`/api-article/delivery-set-clearing/v1/complete-multiple?${query}`);
  },
  done(query) {
    return baseApi.post(`/api-article/delivery-set-clearing/v1/done?${query}`);
  },
  fetchTree(done) {
    return baseApi.get(`/api-article/delivery-set-clearing/v1/tree?onlyDone=${done}`);
  },
  prepareCreditForReport(query) {
    return baseApi.get(`/api-article/delivery-set-clearing/v1/prepare-credit?${query}`);
  }
}
